import { BaseMapper } from '@ps/utils';
import { SurveyScore } from '@ps/survey-utils';

import { SurveyScoreDto } from '../score.dto';

export class SurveyScoreMapper extends BaseMapper<SurveyScoreDto, SurveyScore> {
  public fromDto(dto: SurveyScoreDto): SurveyScore {
    return {
      score: dto.score,
      scorePercentage: dto.scorePercentage,
    };
  }
}
